module.exports = __webpack_public_path__ + "img/79b7fcd.jpg";